import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tabs, Tab } from '@material-ui/core';
import _ from 'lodash';
import { subHours, startOfDay, getUnixTime } from 'date-fns';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { Drawer, Backdrop } from '@material-ui/core';
import { isMobileOnly } from 'react-device-detect';
import { withRouter } from 'react-router-dom';

import './AccountHistory.scss';
import Icon from '../../Icon/Icon';
import { select } from '../../../configs/store';
import AccountStatement from '../AccountStatement/AccountStatement';
import BetHistory from './BetHistory/BetHistory';
import Button from '../../Button/Button';
import GoUpButton from '../../GoUpButton/GoUpButton';
import RangePicker from 'src/components/RangePicker/RangePicker';
import Dropdown from '../Dropdown/Dropdown';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import WalletSelection from '../WalletSelection/WalletSelection';

class AccountHistory extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'betting-history',
      screenWidth: null,
      showFilter: false,
      date1: '',
      date2: '',
      filter: false,
      page: 1,
      activeTab: 'openBets',
      filterTime: 24,
      dateRange: [
        {
          startDate: subHours(new Date(), 24),
          endDate: new Date(),
          key: 'selection'
        }
      ],
      betHistory: [],
      lastPage: false,
      totalItems: 0,
      sort: 'desc',
      product: 'all',
      limit: 10,
      betType: 'allTypes',
      selectedWallet: null
    };
  }

  async componentDidMount () {
    const { tabSelected, history: { location: { pathname } }, wallet, localWallet } = this.props;

    if ((!isMobileOnly && pathname === '/account/account-statement') || (isMobileOnly && tabSelected === 'accountStatement')) {
      this.changeSelected('account-statement');
      return;
    }

    if (!wallet || _.isEmpty(wallet)){
      this.props.updateHistoryWallet(localWallet);
    }

    const data = await this.props.getBetHistory({
      page: 1,
      type: this.state.activeTab,
      sort: this.state.sort,
      product: this.state.product,
      fromDate: getUnixTime(startOfDay(subHours(new Date(), 24))),
      transactionWallet: wallet?.id || localWallet?.id,
      limit: this.state.limit
    });

    this.setState({
      betHistory: _.concat(this.state.betHistory, data.results.collection) || [],
      lastPage: data.lastPage || false,
      totalItems: data.results.totalItems,
      wallet: wallet || localWallet,
      selectedWallet: wallet ||localWallet
    });

    window.addEventListener('resize', this.updateWindowDimensions());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({
      screenWidth: window.innerWidth
    });
  }

  setPage = (newPage) => {
    this.setState({
      page: newPage
    });
  }

  async componentDidUpdate(prevProps) {
    if (!this.state.selectedWallet && this.props.localWallet){
      if (!this.props.wallet || _.isEmpty(this.props.wallet)){
        this.props.updateHistoryWallet(this.props.localWallet);
      }
    }

    if (!this.state.selectedWallet && this.props.wallet){
      this.setState({ selectedWallet: this.props.wallet });
    }

    if (this.props.customer !== prevProps.customer && this.props.wallet) {
      const data = await this.props.getBetHistory({
        page: 1,
        fromDate: getUnixTime(startOfDay(subHours(new Date(), 24))),
        type: this.state.activeTab,
        sort: this.state.sort,
        product: this.state.product,
        transactionWallet: this.state.selectedWallet ? this.state.selectedWallet.id : this.props.wallet.id,
        limit: this.state.limit
      });
      this.setState({ betHistory: _.concat(this.state.betHistory, data.results.collection) || [], lastPage: data.lastPage || false });
    }
  }

  changeSelected = (selected) => {
    const { history } = this.props;
    const path = `/account/${ selected }`;
    (history.location.pathname !== path && !isMobileOnly) && history.replace(path);

    this.setState({
      selected: selected,
      showFilter: false
    });
  }

  setShowFilter = () => {
    this.setState({
      showFilter: !this.state.showFilter,
      filterTime: 0
    });
  }

  onChangeDateValue = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.date1 !== '' && this.state.date2 !== '') {
      this.props.updateFilterDate({ date1: this.state.date1, date2: this.state.date2 });

      this.setState({
        filter: true,
        showFilter: false,
        page: 1
      });
    }

    return;
  }

  clearDates = () => {
    this.props.updateFilterDate({ date1: '', date2: '' });
    this.setState({
      date1: '',
      date2: '',
      filter: false,
      page: 1
    });
  }

  onTabChange = (tab) => {
    if (tab === this.state.activeTab) return;

    this.setState({
      activeTab: tab,
      betHistory: [],
      lastPage: false,
      filterTime: 24,
      totalItems: 0
    }, async () => {
      const data = await this.props.getBetHistory({
        type: tab,
        page: this.state.page,
        fromDate: this.state.activeTab === 'openBets' ?  null : getUnixTime(startOfDay(subHours(new Date(), this.state.filterTime))),
        sort: this.state.sort,
        product: this.state.product,
        transactionWallet: this.state.selectedWallet.id,
        limit: this.state.limit
      });

      this.setState({
        betHistory: _.concat(this.state.betHistory, data.results.collection) || [],
        lastPage: data.lastPage || false,
        totalItems: data.results.totalItems
      });
    });
  }

  onFilterChange = (filter) => async (e) => {
    e.preventDefault();
    const { activeTab, showFilter } = this.state;
    const formattedDate = getUnixTime(startOfDay(subHours(new Date(), filter.value)));

    const data = await this.props.getBetHistory({
      page: 1,
      fromDate: formattedDate,
      type: activeTab,
      sort: this.state.sort,
      product: this.state.product,
      transactionWallet: this.state.selectedWallet.id,
      limit: this.state.limit
    });

    this.setState({
      page: 1,
      filterTime: filter.value,
      betHistory: data.results.collection || [],
      lastPage: data.lastPage || false,
      totalItems: data.results.totalItems,
      showFilter: showFilter ? !showFilter : showFilter
    });
  }

  renderTabs = (tab) => {
    const { t } = this.props;
    const { totalItems, activeTab } = this.state;
    const label = (
      <div className="betting-history__tooltip-container">
        { t(`betHistory.${ tab }`) }
        { activeTab === tab && totalItems > 0 && <span className="betting-history__tooltip">{ totalItems }</span> }
      </div>
    );

    return (
      <Tab
        label={ label }
        onClick={ () => this.onTabChange(tab) }
        key={ tab }
        value={ tab }
        className={
          classNames({
            'betting-history__tab--selected' : this.state.activeTab === tab,
            'betting-history__tab': true
          })
        }
      />
    );
  }

  loadPage = () => {
    const { page, filterTime, dateRange } = this.state;
    const date = getUnixTime(startOfDay(!filterTime ? dateRange[0]?.startDate : subHours(new Date(), filterTime)));
    const fromDate = this.state.activeTab === 'openBets' ? null : date;

    this.setState({ page: page + 1 }, async () => {
      const data = await this.props.getBetHistory({
        page: this.state.page,
        fromDate,
        type: this.state.activeTab,
        sort: this.state.sort,
        product: this.state.product,
        transactionWallet: this.state.selectedWallet.id,
        limit: this.state.limit
      });

      this.setState({ betHistory: _.concat(this.state.betHistory, data.results.collection) || [], lastPage: data.lastPage || false });
    });
  }

  onDateChange = (range) => {
    this.setState({ dateRange: range });
  }

  handleApply = () => {
    this.setState({
      showFilter: false,
      filterTime: null,
      page: 1,
      betHistory: [],
      lastPage: false
    }, async () => {
      const data = await this.props.getBetHistory({
        page: this.state.page,
        fromDate: getUnixTime(this.state.dateRange[0]?.startDate),
        toDate: getUnixTime(this.state.dateRange[0]?.endDate),
        type: this.state.activeTab,
        sort: this.state.sort,
        product: this.state.product,
        transactionWallet: this.state.selectedWallet.id,
        limit: this.state.limit
      });

      this.setState({
        betHistory: data.results.collection || [],
        lastPage: data.lastPage || false,
        totalItems: data.results.totalItems
      });
    });
  }

  handleClear = () => {
    this.setState({
      dateRange: [
        {
          startDate: subHours(new Date(), 96),
          endDate: new Date(),
          key: 'selection'
        }
      ]
    });
  }

  onSortChange = async () => {
    const { sort, dateRange, filterTime } = this.state;
    const newSort = sort === 'desc' ? 'asc' : 'desc';
    const fromDate = getUnixTime(startOfDay(!filterTime ? dateRange[0]?.startDate : subHours(new Date(), filterTime)));

    this.setState({ sort: newSort });

    const data = await this.props.getBetHistory({
      page: 1,
      fromDate,
      type: this.state.activeTab,
      sort: newSort,
      product: this.state.product,
      transactionWallet: this.state.selectedWallet.id || this.props.wallet.id,
      limit: this.state.limit
    });

    this.setState({ betHistory: data.results.collection || [], lastPage: data.lastPage || false });
  }

  onProductChange = async (type) => {
    const { dateRange, filterTime } = this.state;
    const fromDate = getUnixTime(startOfDay(!filterTime ? dateRange[0]?.startDate : subHours(new Date(), filterTime)));
    this.setState({ product: type });

    const data = await this.props.getBetHistory({
      page: 1,
      fromDate,
      type: this.state.activeTab,
      sort: this.state.sort,
      product: type,
      betType: this.state.betType,
      transactionWallet: this.state.selectedWallet.id,
      limit: this.state.limit
    });

    this.setState({ betHistory: data.results.collection || [], lastPage: data.lastPage || false });
  };

  onTypeChange = async (type) => {
    const { dateRange, filterTime } = this.state;
    const fromDate = getUnixTime(startOfDay(!filterTime ? dateRange[0]?.startDate : subHours(new Date(), filterTime)));
    this.setState({ betType: type });

    const data = await this.props.getBetHistory({
      page: 1,
      fromDate,
      type: this.state.activeTab,
      sort: this.state.sort,
      product: this.state.product,
      betType: type,
      transactionWallet: this.state.selectedWallet.id,
      limit: this.state.limit
    });

    this.setState({ betHistory: data.results.collection || [], lastPage: data.lastPage || false });
  };

  onLimitChange = async (limit) => {
    const data = await this.props.getBetHistory({
      page: 1,
      fromDate: getUnixTime(startOfDay(subHours(new Date(), 24))),
      type: this.state.activeTab,
      sort: this.state.sort,
      product: this.state.product,
      transactionWallet: this.state.selectedWallet.id,
      limit: limit
    });

    this.setState({ betHistory: _.concat(data.results.collection) || [], lastPage: data.lastPage || false, limit });
  };

  onWalletChange = async (wallet) => {

    const data = await this.props.getBetHistory({
      page: 1,
      fromDate: getUnixTime(startOfDay(subHours(new Date(), 24))),
      type: this.state.activeTab,
      sort: this.state.sort,
      product: this.state.product,
      transactionWallet: wallet.id,
      limit: this.state.limit
    });
    this.props.updateHistoryWallet(wallet);
    this.setState({ betHistory: _.concat(data.results.collection) || [], lastPage: data.lastPage || false, selectedWallet: wallet });
  }

  renderButtons = () => {
    const { t } = this.props;
    const filterValues = [
      {
        type: 'button',
        value: 24
      },
      {
        type: 'button',
        value: 48
      },
      {
        type: 'button',
        value: 168
      },
      {
        type: 'dropdown',
        value: 'sport'
      }
    ];

    const limitValues = [
      { value: 10, label: '10' },
      { value: 20, label: '20' },
      { value: 50, label: '50' },
      { value: 100, label: '100' }
    ];

    return (
      <div
        className={
          classNames({
            'betting-history__buttons': true
          })
        }
      >
        <div className="betting-history__container--mobile">
          <button
            className={
              classNames({
                'betting-history__sort': true,
                'betting-history__sort--desc' : false
              })
            }
            onClick={ this.onSortChange }
          >
            <Icon className="betting-history__filter" icon={ this.state.sort === 'desc' ? 'descending' : 'ascending' } />
            <span className="betting-history__text-label">{ t(`betHistory.${ this.state.sort === 'desc' ? 'descending' : 'ascending' }`) }</span>
          </button>
          {
            _.map(filterValues, filter => {
              if (filter.type !== 'dropdown') {
                return (
                  <button
                    onClick={ this.onFilterChange(filter) }
                    key={ filter.value }
                    className={
                      classNames({
                        'betting-history__btn': true,
                        'betting-history__btn--selected' : this.state.filterTime === filter.value
                      })
                    }
                  >
                    { t(`betHistory.${ filter.value }`) }
                  </button>
                );
              } else {
                return (
                  <button
                    key={ filter.value }
                    className={
                      classNames({
                        'betting-history__btn': true,
                        'betting-history__btn--selected' : this.state.filterTime === 0
                      })
                    }
                    onClick={ this.setShowFilter }
                  >
                    <Icon className="betting-history__filter" icon="filter" />
                    { t('betHistory.byDate') }
                  </button>
                );
              }
            })
          }
        </div>
        <div className="betting-history__container--mobile">
          <Dropdown dataList={ this.props.rangeFilterDropdown } type={ this.state.product } setType={ this.onProductChange } />
          <Dropdown dataList={ this.props.betType } type={ this.state.betType } setType={ this.onTypeChange } />
          <Dropdown dataList={ limitValues } type={ this.state.limit } setType={ this.onLimitChange } translation={ false } />
        </div>
      </div>
    );
  }

  renderBettinghistory = () => {
    const { t, loading, customer } = this.props;
    const { betHistory, lastPage } = this.state;
    const { RETAIL_MODE } = this.context;
    const tabs = ['openBets', 'settled', 'cancelled'];

    return (
      <div className="betting-history" ref={ this.bettingHistory }>
        <Drawer
          className="betting-history__drawer"
          open={ this.state.showFilter && isMobileOnly }
          anchor={ 'bottom' }
        >
          <RangePicker
            iconClick={ () => this.setState({ showFilter: false }) }
            handleApply = { this.handleApply }
            clear = { this.handleClear }
            dateChange = { this.onDateChange }
            ranges= { this.state.dateRange }
          />
        </Drawer>
        <Backdrop open={ this.state.showFilter } />
        <div className="betting-history__filters">
          {
            this.state.selectedWallet &&
            <WalletSelection
              activeWallet={ this.state.selectedWallet }
              customer={ customer }
              className="statement"
              changeSelectedWallet={ this.onWalletChange }
            />
          }
          { this.renderButtons() }
        </div>
        <div className="betting-history__tabs">
          <Tabs
            value={ this.state.activeTab }
            centered={ true }
            onChange={ (e, value) => this.onTabChange(value) }
            TabIndicatorProps={ { className: 'betting-history__tabs-container' } }
            variant="fullWidth"
          >
            { _.map(tabs, tab => this.renderTabs(tab)) }
          </Tabs>
        </div>
        {
          betHistory.length === 0 && (
            this.state.activeTab === 'openBets' ?
              <span className="betting-history__log-in">{ t('betHistory.noOpenBets') }</span>
              :
              <span className="betting-history__log-in">{ t('betHistory.noSettledBets') }</span>
          )
        }
        <li className={
          classNames({
            'betting-history__list': true,
            'betting-history__list--retail': RETAIL_MODE
          })
        }
        >
          {
            betHistory.length > 0 && _.map(betHistory, item => (
              <BetHistory
                key={ item.ticketNumber + item.registerDate }
                item={ item }
                activeTab={ this.state.activeTab }
                rowColor="white"
              />
            ))
          }
        </li>
        {
          !loading && betHistory.length !== 0 && !lastPage && (
            <Button
              className="btn--primary betting-history__load-more"
              onClick={ this.loadPage }
            >
              { t('betHistory.loadMore') }
            </Button>
          )
        }
        <GoUpButton refElement={ this.props.refElement } showAfterPage={ 2 } />
      </div>
    );
  }

  render() {
    const { t } = this.props;

    return (
      <div className="history">
        {
          this.state.showFilter && !isMobileOnly && (
            <div className="history__filter-container">
              <RangePicker
                iconClick={ () => this.setState({ showFilter: false }) }
                handleApply = { this.handleApply }
                clear = { this.handleClear }
                dateChange = { this.onDateChange }
                ranges= { this.state.dateRange }
              />
            </div>
          )
        }
        <div className="history__nav-menu">
          <div className="history__nav-menu__item--container">
            <span
              className={
                classNames({
                  'history__nav-menu__item--selected': this.state.selected === 'betting-history',
                  'history__nav-menu__item': this.state.selected !== 'betting-history'
                })
              }
              onClick={ () => this.changeSelected('betting-history') }
            >
              { t('accountHistory.bettingHistory') }
            </span>
            <span
              className={
                classNames({
                  'history__nav-menu__item--selected': this.state.selected === 'account-statement',
                  'history__nav-menu__item': this.state.selected !== 'account-statement'
                })
              }
              onClick={ () => this.changeSelected('account-statement') }
            >
              { t('accountHistory.accountStatment') }
            </span>
          </div>
          { /* { !isMobileOnly && this.state.selected === 'betting-history' && this.renderButtons() } */ }
        </div>
        {
          this.state.selected === 'betting-history' ?
            this.renderBettinghistory()
            :
            <AccountStatement />
        }
      </div>
    );
  }
}

AccountHistory.propTypes = {
  t: PropTypes.func,
  accountStatement: PropTypes.array,
  customer: PropTypes.object,
  statistics: PropTypes.array,
  getBetHistory: PropTypes.func,
  loading: PropTypes.bool,
  updateFilterDate: PropTypes.func,
  refElement: PropTypes.any,
  tabSelected: PropTypes.string,
  history: PropTypes.object,
  rangeFilterDropdown: PropTypes.array,
  betType: PropTypes.array,
  updateHistoryWallet: PropTypes.func,
  wallet: PropTypes.object,
  localWallet: PropTypes.object
};

const selection = select(state => ({
  activeWallet: state.auth.activeWallet
}));

const mapState = state => ({
  customer: state.auth.customer,
  statistics: state.account.statistics,
  loading: state.events.loading,
  rangeFilterDropdown: state.content.rangeFilterDropdown,
  betType: state.content.betType,
  localWallet: state.auth.localWalletSelected,
  wallet: state.auth.historySelectedWallet,
  ...selection(state)
});

const mapDispatch = dispatch => ({
  updateFilterDate: (obj) => dispatch.account.updateFilterDate(obj),
  getBetHistory: (page) => dispatch.account.getBetHistory(page),
  updateHistoryWallet: (wallet) => dispatch.auth.updateHistoryWallet(wallet)
});

AccountHistory.contextType = AppModeContext;

export default connect(mapState, mapDispatch)(withRouter(withTranslation('common')(AccountHistory)));
